export default [
    {
        path: 'ficha-vacinacao',
        component: () => import(
            '@/views/atencao-basica/ficha-vacinacao/Index'
        ),
        redirect: 'ficha-vacinacao/index',
        children: [
            {
                name: 'atencao-basica-ficha-vacinacao',
                path: 'index',
                component: () => import(
                    '@/views/atencao-basica/ficha-vacinacao/List'
                ),
            },
            {
                name: 'atencao-basica-ficha-vacinacao-create',
                path: 'create',
                component: () => import(
                    '@/views/atencao-basica/ficha-vacinacao/Form'
                ),
            },
            {
                name: 'atencao-basica-ficha-vacinacao-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    '@/views/atencao-basica/ficha-vacinacao/Edit'
                ),
            },
        ],
    },
]